import { CellGlobalActions } from '@components/organisms/Datatable/cells/CellGlobalActions';

const tableSchemaBase = [
	{
		accessor: 'firstName',
		title: 'global.firstName',
		sortable: true,
		type: 'shortText',
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'lastName',
		title: 'global.lastName',
		sortable: true,
		type: 'shortText',
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'email',
		title: 'global.email',
		sortable: true,
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'phoneNumber',
		title: 'global.phoneNumber',
		type: 'shortText',
		defaultVisible: true,
	},
	{
		accessor: 'language',
		title: 'global.language',
		sortable: true,
		type: 'language',
		defaultVisible: true,
	},
	{
		accessor: 'roleName',
		title: 'global.role',
		sortable: true,
		defaultVisible: true,
	},
	{
		accessor: 'organizationName',
		title: 'global.organization',
		type: 'shortText',
		defaultVisible: true,
	},
	{
		accessor: 'disabled',
		title: 'global.status',
		type: 'userStatus',
		defaultVisible: true,
	},
	{
		accessor: 'lastLoginAt',
		title: 'global.lastLoginAt',
		defaultVisible: true,
	},
	{
		type: 'usersActions',
		accessor: 'actions',
		title: <CellGlobalActions />,
		width: 50,
		resizable: true,
		defaultVisible: true,
	},
];

export { tableSchemaBase };
